import { render, staticRenderFns } from "./RefundDocumentLink.vue?vue&type=template&id=010614e4&scoped=true&"
import script from "./RefundDocumentLink.vue?vue&type=script&lang=js&"
export * from "./RefundDocumentLink.vue?vue&type=script&lang=js&"
import style0 from "./RefundDocumentLink.vue?vue&type=style&index=0&id=010614e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010614e4",
  null
  
)

export default component.exports